import { Compass } from "lucide-react";
import Card from "../../components/ui/Card";
import EmptyState from "../../components/ui/EmptyState";

const NotFound = () => (
  <Card padded={false} className="anim-in">
    <EmptyState
      tone="violet"
      icon={<Compass size={24} />}
      title="Page not found"
      description="That link doesn't lead anywhere. Open the app from inside your CRM account."
    />
  </Card>
);

export default NotFound;
